var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-layout"},[_c('Layout',[_c('Header',[_c('headerCom')],1),_c('Content',[_c('Layout',{staticStyle:{"overflow-x":"auto","padding":"0px"}},[_c('router-view')],1)],1),_c('Footer',[_c('footerCom')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }